import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const categoryIcons: Record<string, string> = {
  all: 'ri-apps-2-line',
  romance: 'ri-heart-line',
  fantasy: 'ri-magic-line',
  action: 'ri-sword-line',
  comedy: 'ri-emotion-laugh-line',
  thriller: 'ri-search-eye-line',
  drama: 'ri-movie-line',
  bl: 'ri-plant-line',
};

const categoryColors: Record<string, string> = {
  all: 'bg-primary-100 text-primary-700',
  romance: 'bg-accent-100 text-accent-700',
  fantasy: 'bg-secondary-100 text-secondary-700',
  action: 'bg-primary-100 text-primary-700',
  comedy: 'bg-accent-100 text-accent-700',
  thriller: 'bg-secondary-100 text-secondary-700',
  drama: 'bg-primary-100 text-primary-700',
  bl: 'bg-accent-100 text-accent-700',
};

export default function CategoryEntrySection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            漫画分类
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按类型探索你喜欢的韩国漫画</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-5 max-w-3xl mx-auto">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={cat.slug === 'all' ? '/category/all' : `/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-6 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors"
            >
              <div className={`w-14 h-14 rounded-2xl flex items-center justify-center ${categoryColors[cat.slug] || 'bg-secondary-100 text-secondary-700'}`}>
                <i className={`${categoryIcons[cat.slug] || 'ri-book-line'} text-2xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}